module.exports = __webpack_public_path__ + "static/media/user_male.704fe86c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_male.png
// module id = 744
// module chunks = 0